import { SDKAction, sdk } from "@squareup/sq-addons-web-sdk";

import { useEffect } from "react";
import {Context as PosContext} from "@squareup/sq-addons-web-sdk/dist/api/sdk/types";

let posContext: PosContext | undefined;
const addonName = posContext?.configurations?.addonName || 'LAVA';

const callbacks = {
  [SDKAction.SDK_GET_ADDON_INFO]: () => ({ title: `${addonName} Loyalty` }),
};

const ActionSlot = () => {
  useEffect(() => {
    const registerGetAddonInfoCallback = async () => {
      //@ts-ignore
      await sdk.initialize(callbacks);
    };

    registerGetAddonInfoCallback();
  }, []);

  return <></>;
};

export default ActionSlot;
